export class DiarioImpressaoNfce {
  private async execute<T>(modo: IDBTransactionMode, acao: (destinos: IDBObjectStore, resultado: (valor: T) => void) => void): Promise<T> {
    const banco = await new Promise<IDBDatabase>((resolve, reject) => {
      const abertura = indexedDB.open('nfce-impressao-pc', 1);
      abertura.onupgradeneeded = () => abertura.result.createObjectStore('destinos');
      abertura.onsuccess = () => resolve(abertura.result);
      abertura.onerror = () => reject(abertura.error);
    });
    return new Promise<T>((resolve, reject) => {
      const transacao = banco.transaction('destinos', modo);
      let resultado: T;
      transacao.oncomplete = () => {banco.close(); resolve(resultado);};
      transacao.onabort = () => {banco.close(); reject(transacao.error || new Error('Não foi possível persistir o despacho da NFC-e.'));};
      acao(transacao.objectStore('destinos'), valor => resultado = valor);
    });
  }

  obtenha(chave: string): Promise<'ENVIADA' | 'INCERTA' | undefined> {
    return this.execute('readonly', (destinos, resultado) => {
      const consulta = destinos.get(chave);
      consulta.onsuccess = () => resultado(consulta.result);
    });
  }

  reserveDespacho(chave: string): Promise<boolean> {
    // A leitura e a gravação compartilham a transação: duas abas não obtêm
    // autorização para o mesmo destino. Só liberamos QZ depois do commit.
    return this.execute('readwrite', (destinos, resultado) => {
      const consulta = destinos.get(chave);
      consulta.onsuccess = () => {
        if(consulta.result) return resultado(false);
        destinos.put('INCERTA', chave);
        resultado(true);
      };
    });
  }

  confirmeEnvio(chave: string): Promise<void> {
    return this.execute('readwrite', destinos => {destinos.put('ENVIADA', chave);});
  }
}
